export default __webpack_public_path__ + "static/media/compass.871fdbb9.svg";